import { useEffect, useState } from 'react';
import { ALLOW_ALL, readConsent, writeConsent } from '@/lib/consent';

/**
 * Cookie notice — the short version.
 *
 * One button, one outcome: Allow. The fuller banner (per-category toggles,
 * Allow Selection, Deny and the details modal) is in the history of this file
 * if the categories ever need to be offered separately again; `lib/consent`
 * still stores them individually, so nothing else has to change when they are.
 *
 * Accepting is what lets the home page's X, Instagram and LinkedIn embeds load
 * — they each set their own cookies, so they stay behind this.
 */
export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Asked once; a stored answer keeps it away.
        if (!readConsent()) setVisible(true);

        const reopen = () => setVisible(true);
        window.addEventListener('cg:open-consent', reopen);
        return () => window.removeEventListener('cg:open-consent', reopen);
    }, []);

    if (!visible) return null;

    return (
        <section
            aria-label="Cookie notice"
            className="fixed inset-x-0 bottom-0 z-[3000] px-4 pb-4 sm:inset-x-auto sm:left-6 sm:max-w-[440px] sm:pb-6"
        >
            <div className="rounded-2xl bg-white p-5 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.35)] ring-1 ring-black/5">
                <p className="text-[15px] font-bold leading-6 text-[#1b1b1b]">Cookies</p>
                <p className="mt-1.5 text-[14px] leading-[22px] text-[#333]">
                    We use cookies to keep the site working.
                </p>
                <button
                    type="button"
                    onClick={() => {
                        writeConsent(ALLOW_ALL);
                        setVisible(false);
                    }}
                    className="mt-4 w-full rounded-[10px] bg-[#f60] px-5 py-2.5 text-[14px] font-bold text-white transition-transform duration-200 hover:scale-[1.02] sm:w-auto sm:px-8"
                >
                    Allow
                </button>
            </div>
        </section>
    );
}
